import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';

export interface CompanyBankAccountInput {
  accountId: string;
  clearingNumber: string;
  customerNumber: string;
  accountNumber: string;
  bankGiroNumber: string;
  bic: string;
  iban: string;
  name: string;
  costPlace: string;
  project: string;
  costBearer: string;
  counterpart: string;
  bankTransactionsImportStartDate: LocalDate;
}

export interface CompanyBankAccountCreate extends CompanyBankAccountInput {
  companyId: string;
}

export interface CompanyBankAccountUpdate extends CompanyBankAccountInput {
  id: string;
}

export class CompanyBankAccount extends ModelBase {
  companyId: string;
  accountingAccountNumber: string;
  accountingAccountName: string;
  clearingNumber: string;
  accountNumber: string;
  accountId: string;
  bankGiroNumber: string;
  bic: string;
  iban: string;
  customerNumber: string;
  name: string;
  defaultInvoiceAccount: boolean;
  costPlace: string;
  project: string;
  costBearer: string;
  counterpart: string;
  bankTransactionsImportStartDate: LocalDate;
  transactionImportedAt: LocalDate;

  toString() {
    return `${this.name} ${this.clearingNumber}-${this.accountNumber}`.trim();
  }
}

export function toCompanyBankAccountUpdate(account: CompanyBankAccount): CompanyBankAccountUpdate {
  return {
    id: account.id,
    accountId: account.accountId,
    clearingNumber: account.clearingNumber,
    customerNumber: account.customerNumber,
    accountNumber: account.accountNumber,
    bankGiroNumber: account.bankGiroNumber,
    bic: account.bic,
    iban: account.iban,
    name: account.name,
    costPlace: account.costPlace,
    project: account.project,
    costBearer: account.costBearer,
    counterpart: account.counterpart,
    bankTransactionsImportStartDate: account.bankTransactionsImportStartDate,
  };
}
